/**
 * One-off confirmation after an action that navigates (an edit submitted, a record created).
 * Carried in router state so it survives exactly one navigation and never a reload.
 */
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router'
import { CircleCheck, Clock, X } from 'lucide-react'

export interface FlashState {
  flash?: { kind: 'applied' | 'pending'; text: string; editId?: string }
}

export function Flash() {
  const location = useLocation()
  const incoming = (location.state as FlashState | null)?.flash
  const [flash, setFlash] = useState(incoming)
  useEffect(() => setFlash(incoming), [incoming, location.key])
  if (!flash) return null
  const Icon = flash.kind === 'applied' ? CircleCheck : Clock
  return (
    <div className={`flash flash-${flash.kind}`} role="status">
      <Icon size={18} aria-hidden="true" />
      <p>
        {flash.text}
        {flash.editId && (
          <>
            {' '}
            <Link to={`/edits/${flash.editId}`}>View the edit</Link>
          </>
        )}
      </p>
      <button type="button" className="icon-button" aria-label="Dismiss" onClick={() => setFlash(undefined)}>
        <X size={16} />
      </button>
    </div>
  )
}
